import { Model } from '@/models/Model';
export class UserPreferences extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'UserPreferences';
        this.$endpoint = '/users/{id}/relationships/preferences';
        this.$fillable = [];
    }
    user(user) {
        if (typeof user !== 'string') {
            user = user.id || '';
        }
        this.$endpoint = `/users/${user}/relationships/preferences`;
        return this;
    }
    setIdAttribute(id) {
        this.$endpoint = `/users/${id}/relationships/preferences`;
        return this;
    }
    resolvePrimaryKey() {
        return '';
    }
}
